import type { CompraDividida, CriarCompraDivididaRequest, CartaoUtilizavel } from '../../types'

/** Máximo de partes que a tela oferece. A API aceita n; subir aqui basta para liberar mais cartões. */
export const MAX_PARTES = 2

export interface ParteForm { cartaoId: string; valor: string; numParcelas: string }

export const partesVazias = (): ParteForm[] => Array.from({ length: 2 }, () => ({ cartaoId: '', valor: '', numParcelas: '1' }))

const centavos = (n: number) => Math.round(n * 100) / 100

/** A última parte recebe o resto: total menos a soma das anteriores. */
export function valorDoResto(total: number, partes: ParteForm[]): number {
  const outras = partes.slice(0, -1).reduce((s, p) => s + (Number(p.valor) || 0), 0)
  return centavos(total - outras)
}

/** Valor efetivo de cada parte (a última é o resto). */
export function valoresDasPartes(total: number, partes: ParteForm[]): number[] {
  return partes.map((p, i) => (i === partes.length - 1 ? valorDoResto(total, partes) : centavos(Number(p.valor) || 0)))
}

export function validarPartes(total: number, partes: ParteForm[]): string | null {
  if (!(total > 0)) return 'Informe o valor total da compra.'
  if (partes.length < 2) return 'Use pelo menos dois cartões na divisão.'
  if (partes.some((p) => !p.cartaoId)) return 'Escolha o cartão de cada parte.'
  const valores = valoresDasPartes(total, partes)
  if (valores.some((v) => !(v > 0))) return 'Cada parte precisa ter valor maior que zero. Confira o valor da primeira parte.'
  return null
}

export function montarRequest(
  base: { description: string; valorTotal: number; date: string; categoriaId?: string; notes?: string; contaCompartilhadaOwnerId?: string | null },
  partes: ParteForm[], cartoes: CartaoUtilizavel[],
): CriarCompraDivididaRequest {
  const valores = valoresDasPartes(base.valorTotal, partes)
  return {
    ...base,
    partes: partes.map((p, i) => {
      const c = cartoes.find((x) => x.id === p.cartaoId)
      // Débito e pré-pago são sempre à vista; só o crédito aceita parcelas.
      const parcelas = c?.aceitaParcelas ? Math.min(24, Math.max(1, Math.floor(Number(p.numParcelas)) || 1)) : 1
      return { cartaoId: p.cartaoId, valor: valores[i], numParcelas: parcelas }
    }),
  }
}

export function partesDaCompra(c: CompraDividida): ParteForm[] {
  return c.partes.map((p) => ({ cartaoId: p.cartaoId, valor: String(p.valor), numParcelas: String(p.numParcelas) }))
}
